import { render, staticRenderFns } from "./packageManage.vue?vue&type=template&id=bb8f94d8&scoped=true&"
import script from "./packageManage.vue?vue&type=script&lang=js&"
export * from "./packageManage.vue?vue&type=script&lang=js&"
import style0 from "./packageManage.vue?vue&type=style&index=0&id=bb8f94d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8f94d8",
  null
  
)

export default component.exports